export enum VariableType {
    JsonPath = 'JsonPath',
    Regex = 'Regex',
    FixedValue = 'FixedValue',
}
